import React, {
    useCallback, useState,
} from 'react';
import { useParams } from 'react-router-dom';

import {
    Infobox, Loader,
} from 'ui-library';
import { useTranslation } from 'react-i18next';
import { InvestorProfileWithProvider } from './InvestorProfileWithProvider';

import './InvestorProfile.css';

export const InvestorProfilesContainer = ({ datasource }: { datasource: (args: { dfsClientId?: string }) => any }) => {
    const { t } = useTranslation();
    const { dfsClientId } = useParams();

    const {
        isJointAccount,
        isUsersLoading,
        productDescription,
        clientAge,
        childClientName,
        targetClientName,
        targetDFSClientId,
    } = datasource({ dfsClientId });
    const [profiles, setProfiles] = useState<Record<string, unknown>>({});

    const onQuestionnaireUpdate = useCallback((key: string, value: unknown) => {
        setProfiles({
            ...profiles,
            [key]: value,
        });
    }, [profiles]);

    if (isUsersLoading) {
        return <Loader />;
    }

    return (
        <>
            <InvestorProfileWithProvider
                clientName={targetClientName}
                clientAge={clientAge}
                title={productDescription}
                sessionStorageKey={`create-portfolio/investor-profile/${targetDFSClientId}/data`}
                dfsClientId={targetDFSClientId}
                onQuestionnaireUpdate={onQuestionnaireUpdate}
            />
            {isJointAccount && (
                <Infobox className="ja-message">
                    {t('portfolio.createNewPortfolio.investorProfile.jaInfoMessage', { clientFullName: childClientName, clientOwnerFullName: targetClientName })}
                </Infobox>
            )}
        </>
    );
};
